import '../assets/styles/SpinnerOverlay.css';

import { brandColors } from '@src/assets/colors/brandColors';
import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

interface SpinnerOverlayProps {
  loading: boolean;
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ loading }) => {
  if (!loading) {
    return null;
  }

  // SSR対応
  const Loader = ('default' in ClipLoader ? ClipLoader.default : ClipLoader) as typeof ClipLoader;

  return (
    <div className='spinner-overlay'>
      <Loader
        size={50}
        color={brandColors['500']}
        loading={loading}
      />
    </div>
  );
};

export default SpinnerOverlay;
